{
  "error-unable-to-create": "Unable to create task. Please try again later",
  "error-unable-to-update": "Unable to update task. Please try again later",
  "error-unable-to-delete": "Unable to delete task. Please try again later",
  "error-unable-to-reorder": "Unable to reorder task. Please try again later",
  "edit-next-steps": "Edit Tasks"
}
